import { render, staticRenderFns } from "./Nav.vue?vue&type=template&id=338720ac&scoped=true"
import script from "./Nav.vue?vue&type=script&lang=ts"
export * from "./Nav.vue?vue&type=script&lang=ts"
import style0 from "./Nav.vue?vue&type=style&index=0&id=338720ac&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "338720ac",
  null
  
)

export default component.exports